/* ============================================================================
FILE: po-katupirsia9-battement-d-or-texts-fr-en-es-20260326.js

MODE: protected trilingual rendering + canonical lexicon safeguarding + audio layer
API:  window.PoKatupirsia9BattementDOrTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='battement_d_or']

ROLE:
  - Bloque la traduction navigateur / Google Translate dans le bloc.
  - Injecte directement FR / EN / ES via boutons de langue.
  - Préserve les termes canoniques via rendu interne contrôlé.
  - CTA fin de page via slot : cta_translate.
  - Ajoute une lecture audio générale et locale par bloc sans remplacer le système existant.
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_BATTEMENT_D_OR_TEXTS_20260326__) return;
  window.__PO_KATUPIRSIA9_BATTEMENT_D_OR_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SELECTOR = ".po-axis-section[data-po-axis='battement_d_or']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Battement_d_or_conceptuel.png?v=1773256141";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Battement_d_or_fonctionnel.png?v=1773256141";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g,"-");
    if (s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "ES";
    if (s.indexOf("en") === 0) return "EN";
    return "FR";
  }

  function detectRawLang(){
    if (typeof window !== "undefined" && window.PO_SITE_LANG) return window.PO_SITE_LANG;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return dl;
    var nav = (typeof navigator !== "undefined") ? navigator : null;
    if (nav && nav.languages && nav.languages.length) return nav.languages[0] || "";
    if (nav && nav.language) return nav.language || "";
    return "fr";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "";
    }catch(e){
      return "";
    }
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function getLang(){
    return readStoredLang() || normLang(detectRawLang()) || "FR";
  }

  function nt(txt){
    return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>';
  }

  var TEXTS = {
    FR: {
      title: "Battement d’Or",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Phases dynamiques du réel et lecture systémique du Souffle d’Or)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel","Idéogramme fonctionnel"],
      def_short: "Pouls cosmique du Souffle : pulsation φ (3-6-9) reliant matière, temps et lumière.",
      def_long:
        "<p>" + nt("Battement d’Or") + " désigne, dans <em>Katûpirsia&nbsp;9</em>, l’une des phases dynamiques du réel. Le corpus le formule de manière resserrée ainsi : « oscillations rythment la respiration du cosmos » ; il en donne le sens opératif : « Pouls cosmique du Souffle : pulsation φ (3-6-9) reliant matière, temps et lumière ».</p>" +
        "<p>Le manuscrit l’articule ensuite à l’" + nt("Équiphase") + " : le " + nt("Battement d’Or") + " est la manifestation sensible de cette " + nt("Équiphase") + ", la pulsation minimale par laquelle l’univers maintient sa cohésion. Chaque battement vaut alors comme remise en phase du monde avec lui-même.</p>" +
        "<p>Dans la lecture systémique intégrée, " + nt("Battement d’Or") + " appartient au plan cosmique, aux côtés de " + nt("Respiration d’Or") + ", " + nt("Cycle d’Or") + " et " + nt("Gravité d’Or") + ". Il participe à la régulation du Δτ, à l’équilibre gravitationnel et au rythme universel.</p>" +
        "<p>Il ne s’agit donc pas d’un battement décoratif ou simplement métaphorique. Dans la logique du corpus, il nomme la loi oscillatoire par laquelle le réel demeure cohérent en respirant, en s’ajustant et en se re-phasant dans le " + nt("Souffle d’Or") + ".</p>",
      h_features: "Dynamiques opératives",
      h_questions: "Applications / repères",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      hint_fold: "déplier",
      example_title: "Ex.",
      example: "Dans une lecture posœnnoïale du rythme, le moment où une forme, un souffle ou un champ se réaccorde sans se figer peut être lu comme un Battement d’Or : retour de cohérence plutôt qu’arrêt du mouvement.",
      features: [
        "Phase dynamique du réel : le Battement d’Or appartient aux mouvements respiratoires du cosmos.",
        "Pouls cosmique du Souffle : il exprime une pulsation φ (3-6-9) reliant matière, temps et lumière.",
        "Manifestation sensible de l’Équiphase : il rend perceptible l’accord cohérent entre rythme, mesure et souffle.",
        "Remise en phase du monde : chaque battement réajuste le réel avec lui-même.",
        "Plan cosmique : dans la lecture systémique, il participe à la régulation du Δτ, à l’équilibre gravitationnel et au rythme universel."
      ],
      questions: [
        "Le mouvement observé relève-t-il d’une simple répétition, ou d’un réaccord vivant du champ ?",
        "Où le rythme relie-t-il ici matière, temps et lumière dans une même pulsation ?",
        "Le battement perçu manifeste-t-il une Équiphase, c’est-à-dire une cohérence entre plusieurs plans ?",
        "Quel signe indique la remise en phase : retour de tenue, régulation, respiration, cohésion retrouvée ?"
      ],
      family_1:
        "<p><strong>Liens internes :</strong> " + nt("Battement d’Or") + " appartient au plan cosmique de la grammaire dorée, avec " + nt("Respiration d’Or") + ", " + nt("Cycle d’Or") + " et " + nt("Gravité d’Or") + ". Il se rapporte directement au " + nt("Souffle d’Or") + ", dont il constitue la pulsation sensible.</p>",
      family_2:
        "<p><strong>Fonction systémique :</strong> dans le manuscrit, il est articulé à l’" + nt("Équiphase") + " : le réel tient parce qu’il oscille à la mesure du souffle. Le " + nt("Battement d’Or") + " vaut comme retour cohérent de la forme à sa lumière, et comme remise en phase du monde avec lui-même.</p>",
      word_blocks: [
        { head: "1) Battement", text: "Pulsation, oscillation, retour rythmique par lequel un champ maintient sa cohérence dans le mouvement." },
        { head: "2) d’Or", text: "Rapport au Souffle d’Or, à la proportion vivante du φ et à la loi respiratoire du 3-6-9." },
        { head: "3) Ensemble", text: "L’expression nomme le pouls cosmique du Souffle : la pulsation minimale par laquelle matière, temps et lumière se remettent en phase." }
      ],
      word_notes: [
        "Plan principal : cosmique.",
        "Fonction : pulsation du Souffle, articulation du φ (3-6-9), remise en phase du monde."
      ],
      cta_translate: "Proposer une traduction du concept",
      cta_aria: "Proposer une traduction — Lexique simplifié",
      langbar_aria: "Choix de langue",
      audio_general: "Écouter le texte",
      audio_block: "Écouter ce bloc",
      audio_stop: "Arrêter la lecture"
    },

    EN: {
      title: "Battement d’Or",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Dynamic phases of reality and systemic reading of the Souffle d’Or)",
      h_def: "Operative definition",
      chips: ["Conceptual ideogram","Functional ideogram"],
      def_short: "Cosmic pulse of the Souffle: φ-pulsation (3-6-9) linking matter, time, and light.",
      def_long:
        "<p>" + nt("Battement d’Or") + " designates, in <em>Katûpirsia&nbsp;9</em>, one of the dynamic phases of reality. The corpus formulates it concisely as follows: « oscillations rhythm the breathing of the cosmos »; it then gives its operative meaning: « Cosmic pulse of the Souffle: φ-pulsation (3-6-9) linking matter, time, and light ».</p>" +
        "<p>The manuscript then connects it to " + nt("Équiphase") + ": the " + nt("Battement d’Or") + " is the sensible manifestation of this " + nt("Équiphase") + ", the minimal pulsation through which the universe maintains its cohesion. Each beat then acts as a re-phasing of the world with itself.</p>" +
        "<p>Within the integrated systemic reading, " + nt("Battement d’Or") + " belongs to the cosmic plane, alongside " + nt("Respiration d’Or") + ", " + nt("Cycle d’Or") + " and " + nt("Gravité d’Or") + ". It takes part in the regulation of Δτ, in gravitational balance, and in the universal rhythm.</p>" +
        "<p>It is therefore not a decorative or merely metaphorical beat. Within the logic of the corpus, it names the oscillatory law through which reality remains coherent by breathing, adjusting itself, and re-phasing itself within the " + nt("Souffle d’Or") + ".</p>",
      h_features: "Operative dynamics",
      h_questions: "Applications / markers",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      hint_fold: "expand",
      example_title: "Ex.",
      example: "In a posœnnoïal reading of rhythm, the moment when a form, a breath, or a field retunes itself without freezing may be read as a Battement d’Or: a return of coherence rather than a halt in movement.",
      features: [
        "Dynamic phase of reality: the Battement d’Or belongs to the respiratory movements of the cosmos.",
        "Cosmic pulse of the Souffle: it expresses a φ-pulsation (3-6-9) linking matter, time, and light.",
        "Sensible manifestation of Équiphase: it makes perceptible the coherent accord between rhythm, measure, and breath.",
        "Re-phasing of the world: each beat readjusts reality with itself.",
        "Cosmic plane: within the systemic reading, it participates in the regulation of Δτ, gravitational balance, and universal rhythm."
      ],
      questions: [
        "Does the observed movement belong to mere repetition, or to a living retuning of the field?",
        "Where does rhythm here link matter, time, and light in a single pulsation?",
        "Does the perceived beat manifest an Équiphase, that is, a coherence between several planes?",
        "What sign indicates re-phasing: return of poise, regulation, respiration, or restored cohesion?"
      ],
      family_1:
        "<p><strong>Internal links:</strong> " + nt("Battement d’Or") + " belongs to the cosmic plane of the golden grammar, together with " + nt("Respiration d’Or") + ", " + nt("Cycle d’Or") + ", and " + nt("Gravité d’Or") + ". It relates directly to the " + nt("Souffle d’Or") + ", of which it forms the sensible pulsation.</p>",
      family_2:
        "<p><strong>Systemic function:</strong> in the manuscript, it is articulated with " + nt("Équiphase") + ": reality holds together because it oscillates according to the measure of breath. The " + nt("Battement d’Or") + " acts as the coherent return of form to its light, and as the re-phasing of the world with itself.</p>",
      word_blocks: [
        { head: "1) Beat", text: "Pulsation, oscillation, rhythmic return through which a field maintains its coherence in movement." },
        { head: "2) d’Or", text: "Relation to the Souffle d’Or, to the living proportion of φ, and to the respiratory law of 3-6-9." },
        { head: "3) Whole term", text: "The expression names the cosmic pulse of the Souffle: the minimal pulsation through which matter, time, and light return into phase." }
      ],
      word_notes: [
        "Main plane: cosmic.",
        "Function: pulsation of the Souffle, articulation of φ (3-6-9), re-phasing of the world."
      ],
      cta_translate: "Propose a translation of the concept",
      cta_aria: "Propose a translation — Simplified lexicon",
      langbar_aria: "Language selection",
      audio_general: "Listen to the text",
      audio_block: "Listen to this block",
      audio_stop: "Stop playback"
    },

    ES: {
      title: "Battement d’Or",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 — Àṣẹxel’Or</em><br />(Fases dinámicas de lo real y lectura sistémica del Souffle d’Or)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual","Ideograma funcional"],
      def_short: "Pulso cósmico del Souffle: pulsación φ (3-6-9) que vincula materia, tiempo y luz.",
      def_long:
        "<p>" + nt("Battement d’Or") + " designa, en <em>Katûpirsia&nbsp;9</em>, una de las fases dinámicas de lo real. El corpus lo formula de manera condensada así: « las oscilaciones ritman la respiración del cosmos »; y le da este sentido operativo: « Pulso cósmico del Souffle: pulsación φ (3-6-9) que vincula materia, tiempo y luz ».</p>" +
        "<p>Luego, el manuscrito lo articula con la " + nt("Équiphase") + ": el " + nt("Battement d’Or") + " es la manifestación sensible de esa " + nt("Équiphase") + ", la pulsación mínima por la cual el universo mantiene su cohesión. Cada latido vale entonces como una nueva puesta en fase del mundo consigo mismo.</p>" +
        "<p>En la lectura sistémica integrada, " + nt("Battement d’Or") + " pertenece al plano cósmico, junto a " + nt("Respiration d’Or") + ", " + nt("Cycle d’Or") + " y " + nt("Gravité d’Or") + ". Participa en la regulación de Δτ, en el equilibrio gravitacional y en el ritmo universal.</p>" +
        "<p>Por tanto, no se trata de un latido decorativo ni meramente metafórico. En la lógica del corpus, nombra la ley oscilatoria por la cual lo real permanece coherente al respirar, ajustarse y volver a ponerse en fase dentro del " + nt("Souffle d’Or") + ".</p>",
      h_features: "Dinámicas operativas",
      h_questions: "Aplicaciones / referencias",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example: "En una lectura posœnnoïal del ritmo, el momento en que una forma, un soplo o un campo se reajusta sin inmovilizarse puede leerse como un Battement d’Or: retorno de coherencia en vez de detención del movimiento.",
      features: [
        "Fase dinámica de lo real: el Battement d’Or pertenece a los movimientos respiratorios del cosmos.",
        "Pulso cósmico del Souffle: expresa una pulsación φ (3-6-9) que vincula materia, tiempo y luz.",
        "Manifestación sensible de la Équiphase: vuelve perceptible el acuerdo coherente entre ritmo, medida y soplo.",
        "Nueva puesta en fase del mundo: cada latido reajusta lo real consigo mismo.",
        "Plano cósmico: en la lectura sistémica, participa en la regulación de Δτ, en el equilibrio gravitacional y en el ritmo universal."
      ],
      questions: [
        "¿El movimiento observado pertenece a una simple repetición, o a un reajuste vivo del campo?",
        "¿Dónde vincula aquí el ritmo materia, tiempo y luz en una misma pulsación?",
        "¿El latido percibido manifiesta una Équiphase, es decir, una coherencia entre varios planos?",
        "¿Qué signo indica la nueva puesta en fase: retorno de la tenida, regulación, respiración o cohesión recuperada?"
      ],
      family_1:
        "<p><strong>Vínculos internos:</strong> " + nt("Battement d’Or") + " pertenece al plano cósmico de la gramática dorada, junto con " + nt("Respiration d’Or") + ", " + nt("Cycle d’Or") + " y " + nt("Gravité d’Or") + ". Se relaciona directamente con el " + nt("Souffle d’Or") + ", del cual constituye la pulsación sensible.</p>",
      family_2:
        "<p><strong>Función sistémica:</strong> en el manuscrito, se articula con la " + nt("Équiphase") + ": lo real se sostiene porque oscila según la medida del soplo. El " + nt("Battement d’Or") + " vale como retorno coherente de la forma a su luz, y como nueva puesta en fase del mundo consigo mismo.</p>",
      word_blocks: [
        { head: "1) Latido", text: "Pulsación, oscilación, retorno rítmico por el cual un campo mantiene su coherencia en el movimiento." },
        { head: "2) d’Or", text: "Relación con el Souffle d’Or, con la proporción viva de φ y con la ley respiratoria del 3-6-9." },
        { head: "3) Conjunto", text: "La expresión nombra el pulso cósmico del Souffle: la pulsación mínima por la cual materia, tiempo y luz vuelven a ponerse en fase." }
      ],
      word_notes: [
        "Plano principal: cósmico.",
        "Función: pulsación del Souffle, articulación de φ (3-6-9), nueva puesta en fase del mundo."
      ],
      cta_translate: "Proponer una traducción del concepto",
      cta_aria: "Proponer una traducción — Léxico simplificado",
      langbar_aria: "Choix de langue",
      audio_general: "Escuchar el texto",
      audio_block: "Escuchar este bloque",
      audio_stop: "Detener la lectura"
    }
  };

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    if (src) el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt || ""));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    for (var i = 0; i < (items || []).length; i++){
      var li = document.createElement("li");
      li.innerHTML = clampStr(items[i]);
      el.appendChild(li);
    }
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    for (var i = 0; i < (blocks || []).length; i++){
      var b = blocks[i] || {};
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";

      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr(b.head || "");

      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr(b.text || "");

      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    }
  }

  function lockScope(root, lang3){
    if (!root) return;
    root.classList.add("notranslate");
    root.setAttribute("translate", "no");
    root.setAttribute("lang", normLang(lang3).toLowerCase());

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope){
      scope.classList.add("notranslate");
      scope.setAttribute("translate", "no");
      scope.setAttribute("lang", normLang(lang3).toLowerCase());
    }
  }

  function updateLangButtons(root, lang3){
    var btns = root.querySelectorAll(".po-langbtn[data-po-lang]");
    for (var i = 0; i < btns.length; i++){
      var active = normLang(btns[i].getAttribute("data-po-lang")) === normLang(lang3);
      btns[i].classList.toggle("is-active", active);
      btns[i].setAttribute("aria-pressed", active ? "true" : "false");
    }
  }

  function setA11y(root, lang3){
    var T = TEXTS[normLang(lang3)] || TEXTS.FR;
    var bar = root.querySelector(".po-langbar");
    var cta = root.querySelector(".po-axis-breath-link");
    if (bar) bar.setAttribute("aria-label", clampStr(T.langbar_aria));
    if (cta) cta.setAttribute("aria-label", clampStr(T.cta_aria));
  }

  function wireButtons(root){
    if (!root || root.__po_lang_wired) return;
    root.__po_lang_wired = true;
    var btns = root.querySelectorAll(".po-langbtn[data-po-lang]");
    for (var i = 0; i < btns.length; i++){
      btns[i].addEventListener("click", function(ev){
        ev.preventDefault();
        applyLangEverywhere(this.getAttribute("data-po-lang"));
      });
    }
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    isStopping: false
  };

  function audioUI(lang3){
    var T = TEXTS[normLang(lang3)] || TEXTS.FR;
    return {
      general: T.audio_general,
      block: T.audio_block,
      stop: T.audio_stop
    };
  }

  function getSpeechLang(lang3){
    var L = normLang(lang3);
    if (L === "EN") return "en-US";
    if (L === "ES") return "es-ES";
    return "fr-FR";
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k9-battement-d-or-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k9-battement-d-or-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:flex-start;align-items:center;margin:10px 0 12px;}" +
      ".po-axis-audio-btn{" +
        "appearance:none;border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.66);" +
        "border-radius:999px;padding:7px 12px;font:inherit;font-size:12px;font-weight:700;" +
        "letter-spacing:.02em;cursor:pointer;transition:all .18s ease;line-height:1.2;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.04);}" +
      ".po-axis-audio-btn.is-playing{background:rgba(184,134,11,.08);border-color:rgba(184,134,11,.45);}" +
      ".po-axis-audio-btn[data-po-audio-kind='block']{margin-left:auto;flex:0 0 auto;}" +
      ".po-lex-summary{position:relative;}" +
      ".po-lex-summary__title{display:inline-flex;align-items:center;gap:10px;min-width:0;}" +
      "@media (max-width:760px){.po-axis-audio-btn{font-size:11px;padding:7px 10px;}}";
    document.head.appendChild(style);
  }

  function clearPlayingButtons(){
    var all = document.querySelectorAll(".po-axis-audio-btn.is-playing");
    for (var i = 0; i < all.length; i++) all[i].classList.remove("is-playing");
  }

  function stopAudio(){
    PO_AUDIO_STATE.isStopping = true;
    try{
      if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel();
    }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    clearPlayingButtons();
    setTimeout(function(){ PO_AUDIO_STATE.isStopping = false; }, 0);
  }

  function setPlayingButtons(root, key){
    clearPlayingButtons();
    if (!root || !key) return;
    var btn = root.querySelector(".po-axis-audio-btn[data-po-audio-key='" + key + "']");
    if (btn) btn.classList.add("is-playing");
  }

  function cleanText(text){
    return clampStr(text)
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\s+([,.;:!?])/g, "$1")
      .trim();
  }

  function getNodeText(el){
    if (!el) return "";
    return cleanText(el.textContent || el.innerText || "");
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i = 0; i < slots.length; i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      if (el) parts.push(getNodeText(el));
    }
    return cleanText(parts.join(" "));
  }

  function collectBlockText(details){
    if (!details) return "";
    var parts = [];
    var summaryTitle = details.querySelector(".po-lex-summary__title");
    if (summaryTitle) parts.push(getNodeText(summaryTitle));

    var clone = details.cloneNode(true);
    var summary = clone.querySelector("summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    var buttons = clone.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < buttons.length; i++){
      if (buttons[i] && buttons[i].parentNode) buttons[i].parentNode.removeChild(buttons[i]);
    }
    parts.push(getNodeText(clone));
    return cleanText(parts.join(" "));
  }

  function splitSpeechText(text){
    var source = cleanText(text);
    if (!source) return [];
    var maxLen = 210;
    var out = [];
    var current = "";
    var segments = source.split(/(?<=[\.\!\?\:\;])\s+/);

    function pushCurrent(){
      current = cleanText(current);
      if (current) out.push(current);
      current = "";
    }

    for (var i = 0; i < segments.length; i++){
      var seg = cleanText(segments[i]);
      if (!seg) continue;
      if (!current){
        current = seg;
      } else if ((current + " " + seg).length <= maxLen){
        current += " " + seg;
      } else {
        pushCurrent();
        if (seg.length <= maxLen){
          current = seg;
        } else {
          var words = seg.split(/\s+/);
          var buffer = "";
          for (var j = 0; j < words.length; j++){
            var w = words[j];
            if (!buffer){
              buffer = w;
            } else if ((buffer + " " + w).length <= maxLen){
              buffer += " " + w;
            } else {
              out.push(cleanText(buffer));
              buffer = w;
            }
          }
          current = buffer;
        }
      }
    }
    pushCurrent();
    return out;
  }

  function createUtterance(text, lang3, onEnd){
    var u = new SpeechSynthesisUtterance(text);
    u.lang = getSpeechLang(lang3);
    u.rate = 1;
    u.pitch = 1;
    u.volume = 1;
    u.onend = function(){ if (typeof onEnd === "function") onEnd(); };
    u.onerror = function(){ if (typeof onEnd === "function") onEnd(); };
    return u;
  }

  function speakChunks(chunks, lang3, done){
    if (!PO_AUDIO_SYNTH || !chunks.length){
      if (typeof done === "function") done();
      return;
    }
    var idx = 0;
    function next(){
      if (PO_AUDIO_STATE.isStopping) return;
      if (idx >= chunks.length){
        if (typeof done === "function") done();
        return;
      }
      var utter = createUtterance(chunks[idx], lang3, function(){ idx += 1; next(); });
      try{ PO_AUDIO_SYNTH.speak(utter); }
      catch(e){ idx += 1; next(); }
    }
    next();
  }

  function buildUnits(root){
    var units = [];
    var generalText = collectGeneralText(root);
    if (generalText){
      units.push({
        key: "general",
        type: "general",
        node: root,
        getText: function(){ return collectGeneralText(root); }
      });
    }
    var blocks = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < blocks.length; i++){
      (function(index, details){
        units.push({
          key: "block-" + index,
          type: "block",
          node: details,
          getText: function(){ return collectBlockText(details); }
        });
      })(i, blocks[i]);
    }
    return units;
  }

  function playUnitSequence(root, startIndex){
    if (!root || !PO_AUDIO_SYNTH) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root);
    PO_AUDIO_STATE.unitPos = startIndex;
    if (startIndex < 0 || startIndex >= PO_AUDIO_STATE.units.length) return;

    function playCurrent(){
      if (PO_AUDIO_STATE.isStopping) return;
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      if (!unit){ stopAudio(); return; }

      if (unit.type === "block" && unit.node && !unit.node.open) unit.node.open = true;

      PO_AUDIO_STATE.activeKey = unit.key;
      setPlayingButtons(root, unit.key);

      var txt = cleanText(unit.getText());
      var chunks = splitSpeechText(txt);
      var lang3 = getLang();

      if (!chunks.length){
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) stopAudio();
        else playCurrent();
        return;
      }

      speakChunks(chunks, lang3, function(){
        if (PO_AUDIO_STATE.isStopping) return;
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) stopAudio();
        else playCurrent();
      });
    }

    playCurrent();
  }

  function createAudioButton(kind, key){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    return btn;
  }

  function updateAudioButtonLabels(root, lang3){
    var ui = audioUI(lang3);
    var all = root.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < all.length; i++){
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind");
      var isPlaying = btn.classList.contains("is-playing");
      btn.textContent = isPlaying ? ui.stop : (kind === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-label", btn.textContent);
    }
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector(".po-lex-panel");
    if (!panel) return;

    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general", "general"));

      var meta = panel.querySelector(".po-axis-meta");
      var defShort = panel.querySelector("[data-po-slot='def_short']");
      var firstDetails = panel.querySelector(".po-lex-details");

      if (meta && meta.parentNode === panel && meta.nextSibling) panel.insertBefore(generalWrap, meta.nextSibling);
      else if (defShort && defShort.parentNode === panel) panel.insertBefore(generalWrap, defShort);
      else if (firstDetails && firstDetails.parentNode === panel) panel.insertBefore(generalWrap, firstDetails);
      else panel.appendChild(generalWrap);
    }

    var details = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < details.length; i++){
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-kind='block']");
      if (!btn){
        btn = createAudioButton("block", "block-" + i);
        summary.appendChild(btn);
      } else {
        btn.setAttribute("data-po-audio-key", "block-" + i);
      }
    }
  }

  function bindAudioHandlers(root){
    if (!root || root.__poAudioBound) return;
    root.__poAudioBound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;

      ev.preventDefault();
      ev.stopPropagation();

      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");

      if (isPlaying){
        stopAudio();
        updateAudioButtonLabels(root, getLang());
        return;
      }

      var units = buildUnits(root);
      var startIndex = 0;
      for (var i = 0; i < units.length; i++){
        if (units[i].key === key){ startIndex = i; break; }
      }
      playUnitSequence(root, startIndex);
      updateAudioButtonLabels(root, getLang());
    }, true);
  }

  function initAudioEverywhere(lang3){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++){
      ensureAudioButtons(roots[i]);
      bindAudioHandlers(roots[i]);
      updateAudioButtonLabels(roots[i], lang3);
    }
  }

  function renderRoot(root, lang3){
    var T = TEXTS[normLang(lang3)] || TEXTS.FR;

    lockScope(root, lang3);
    setA11y(root, lang3);

    setSlotText(root, "title", T.title);
    setSlotHTML(root, "kicker", T.kicker);

    setSlotImgSrc(root, "title_img", CONCEPT_URL, T.title);

    setSlotText(root, "h_def", T.h_def);
    setSlotText(root, "chip_1", T.chips[0] || "");
    setSlotText(root, "chip_2", T.chips[1] || "");

    setSlotImgSrc(root, "chip_1_img", CONCEPT_URL, T.chips[0] || "");
    setSlotImgSrc(root, "chip_2_img", FUNCTION_URL, T.chips[1] || "");

    setSlotText(root, "def_short", T.def_short);
    setSlotHTML(root, "def_long", T.def_long);

    setSlotText(root, "h_features", T.h_features);
    setSlotText(root, "h_questions", T.h_questions);
    setSlotText(root, "h_family", T.h_family);
    setSlotText(root, "h_wordbuild", T.h_wordbuild);

    setSlotText(root, "hint_fold", T.hint_fold);
    setSlotText(root, "hint_fold2", T.hint_fold);
    setSlotText(root, "hint_fold3", T.hint_fold);
    setSlotText(root, "hint_fold4", T.hint_fold);

    renderListInto(root, "features", T.features || []);
    renderListInto(root, "questions", T.questions || []);
    setSlotHTML(root, "example_box", "<div><strong>" + clampStr(T.example_title || "") + "</strong> " + clampStr(T.example || "") + "</div>");
    setSlotHTML(root, "family_1", T.family_1 || "");
    setSlotHTML(root, "family_2", T.family_2 || "");
    renderWordBlocks(root, "wordbuild_blocks", T.word_blocks || []);
    renderListInto(root, "wordbuild_notes", T.word_notes || []);
    setSlotText(root, "cta_translate", T.cta_translate || "");

    updateLangButtons(root, lang3);
  }

  function applyLangEverywhere(lang3){
    lang3 = normLang(lang3);
    storeLang(lang3);

    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++){
      wireButtons(roots[i]);
      renderRoot(roots[i], lang3);
    }

    initAudioEverywhere(lang3);
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoKatupirsia9BattementDOrTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

})();